
const header = document.querySelector('.header');
const navToggle = document.querySelector('.header__cta--navigation');
const siteSearchToggle = document.querySelector('.header__cta--site-search');

let ticking = false;
document.addEventListener('scroll', () => {
    if (!ticking) {
        requestAnimationFrame(() => {
            document.body.style.setProperty('--header-offset', `${header.getBoundingClientRect().top}px`);
            ticking = false;
        });
        ticking = true;
    }
});

navToggle.addEventListener('click', (e) => {
    document.body.classList.remove('site-search-active');

    if (document.body.classList.contains('nav-active')) {
        document.body.classList.remove('nav-active');
        navToggle.setAttribute('aria-expanded', 'false');
    } else {
        document.body.classList.add('nav-active');
        navToggle.setAttribute('aria-expanded', 'true');
        siteSearchToggle.setAttribute('aria-expanded', 'false');
    }

    e.preventDefault();
});

siteSearchToggle.addEventListener('click', (e) => {
    document.body.classList.remove('nav-active');

    if (document.body.classList.contains('site-search-active')) {
        document.body.classList.remove('site-search-active');
        siteSearchToggle.setAttribute('aria-expanded', 'false');
    } else {
        document.body.classList.add('site-search-active');
        siteSearchToggle.setAttribute('aria-expanded', 'true');
        navToggle.setAttribute('aria-expanded', 'false');
    }

    e.preventDefault();
});

document.querySelectorAll('.nav__submenu-toggle').forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
        toggle.closest('.nav__item').classList.toggle('nav__item--active');
    });
});
